module.exports = __webpack_public_path__ + "static/img/talentenspel_begeleiding_1.51af868.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/talentenspel_begeleiding_1.jpg
// module id = w+BS
// module chunks = 0